export default "__VITE_ASSET__B6zGPNZ2__"